import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAnalysisResultsText from './reducers/analysis-results-text.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AnalysisResultsTextEffects } from './effects/analysis-results-text.effects';
import { AnalysisResultsTextService } from './/services/analysis-results-text.service';
import { AnalysisResultsTextStoreFacade } from './facades/analysis-results-text-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromAnalysisResultsText.analysisResultsTextsFeatureKey,
      fromAnalysisResultsText.reducer
    ),
    EffectsModule.forFeature([AnalysisResultsTextEffects]),
  ],
  providers: [AnalysisResultsTextService, AnalysisResultsTextStoreFacade],
})
export class AnalysisResultsTextModule {}
